import { isEmpty } from 'lodash';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

import { RemoveIcon } from '@assets/icons';

const selectedFilterConfig = [
    {
        key: 'dc_name',
        label: 'Distribution Center',
        getDisplayValue: (val) => `${val?.length} Terpilih`,
    },
    {
        key: 'sales_area_name',
        label: 'Sales Area',
        getDisplayValue: (val) => `${val?.length} Terpilih`,
    },
    {
        key: 'parahub_name',
        label: 'Parahub',
        getDisplayValue: (val) => `${val?.length} Terpilih`,
    },
];

export default function SelectedFilterList({ filtersState, onRemoveFilterItem, onResetFilter }) {
    return (
        <Flex alignItems={'center'} gap={'16px'}>
            <Text fontWeight={700} fontSize={'14px'}>
                Filters by:
            </Text>

            {selectedFilterConfig.map(({ key, label, getDisplayValue }) => {
                const value = filtersState?.[key];
                const isActive = Array.isArray(value) ? value.length > 0 : !isEmpty(value);

                if (!isActive) return null;

                return (
                    <Flex
                        key={key}
                        p={'8px'}
                        gap={'8px'}
                        bg={'semantic.200'}
                        borderRadius={'2px'}
                        alignItems={'center'}
                    >
                        <Text fontWeight={700} fontSize={'12px'}>
                            {label}:{' '}
                            <Box display={'inline'} fontWeight={'400'}>
                                {getDisplayValue(value)}
                            </Box>
                        </Text>
                        <Box onClick={() => onRemoveFilterItem(key)} cursor={'pointer'}>
                            <RemoveIcon />
                        </Box>
                    </Flex>
                );
            })}

            <Button variant={'outline'} onClick={onResetFilter} size={'sm'}>
                Reset All
            </Button>
        </Flex>
    );
}
